// 简历
import React from "react";

import 'dayjs/locale/zh-cn';
import { setXinZi } from "../utils";
import { sleep } from 'antd-mobile/es/utils/sleep';
import { Button, Form, Steps, Input, Select, Radio, DatePicker, Space, InputNumber, Divider, Modal, Upload, Image } from "antd";
import { PlusCircleOutlined, CloseOutlined, PlusOutlined } from '@ant-design/icons';
import locale from 'antd/locale/zh_CN';
import dayjs from 'dayjs';

import Config from "../../config/Config";
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetMessage from "../../widget/WidgetMessage";
import WidgetPositionDate from "../../widget/WidgetPositionDate";

import './../../css/pinzhunzhun/component/resume.scss';

dayjs.locale('zh-cn');

const path = Config.getBasePath();

let filePath = Config.getFilePath();

class Resume extends React.Component 
{
    constructor( props )
    {
        super( props );

        let useInfo = JSON.parse(sessionStorage.getItem('_user_info_'));
        let applicant_id = useInfo.extensions.applicant_id;

        this.state = {
            applicant_id: applicant_id,
            useInfo: useInfo || {},
            isEditObj: {
            },
            info: {},
            noDealWithInfo: {},
            resumeList: [
                { 
                    name: "基本信息", id: "baseInfo", 
                    list: [
                        { name: "性别", props: "SEX_CN", },
                        { name: "年龄", props: "AGE" },
                        { name: "学历", props: "EDU_CN" },
                        { name: "经验", props: "IDENTITY_CN" },
                        { name: "邮箱", props: "EMAIL" },
                        { name: "手机号", props: "CELL" },
                        { name: "住址", props: "RESADDRESS" },
                        { name: "是否定居本地", props: "STLDISTRICT", type: "STLDISTRICT" },
                        { name: "求职状态", props: "STATUS_CN" },
                    ],
                    formList: [
                        { 
                            name: "姓名", type: 'input', props: "PERNAME", placeholder: "请输入姓名",
                            rules: [{ required: true, message: '请输入姓名' }], 
                        },
                        { name: "电话", type: 'input', props: "CELL", placeholder: "请输入电话号码" },
                        { 
                            name: "性别", type: 'radio', props: "SEX", options: [{ label: '男', value: '1' }, { label: '女', value: '2' }],
                            rules: [{ required: true, message: '请选择性别' }],
                        },
                        { 
                            name: "出生年月", type: 'DatePicker', props: "BRTHDATE", 
                            rules: [{ required: true, message: '请选择出生年月' }],
                        },
                        { 
                            name: "工作经验", type: 'radio', props: "IDENTITY", 
                            options: [
                                {label:"职场人", value:"11"},
                                {label:"应届生", value:"14"}, 
                                {label:"在校生", value:"13"},
                            ] 
                        },
                        { name: "工作日期", type: 'DatePicker', props: "WKDATE" },
                        { name: "学历", type: 'select', props: "EDU", options: [], optionsProps: "eduOptions" },
                        { name: "邮箱", type: 'input', props: "EMAIL" },
                        { 
                            name: "地址", type: 'input', props: "RESADDRESS", className: "sf-all-form-width", 
                            formProps: { 
                                labelCol: { span: 4 },
                                wrapperCol: { span: 20 },
                            } 
                        },
                        { 
                            name: "是否定居本地", type: 'radio', props: "STLDISTRICT", 
                            options:[
                                { label: '否', value: 0 },
                                { label: '是', value: 1 },
                            ] 
                        },
                        { name: "求职状态", type: 'select', props: "STATUS", options: [], optionsProps: "statusOptions" },
                    ],
                    formProps: {
                        labelCol: { span: 8 },
                        wrapperCol: { span: 16 },
                    },
                    onFinish: (data, value) => {
                        const { info } = this.state;
                        let params = {
                            ...value,
                            id: applicant_id,
                            BRTHDATE: dayjs(value.BRTHDATE).format('YYYY-MM-DD'),
                            WKDATE: dayjs(value.WKDATE).format('YYYY-MM-DD'),
                            STLDISTRICT: value.STLDISTRICT == 1 ? info.DISTRICT : 100000
                        }

                        WidgetAjax.ajax({
                            url: path + "/applicant/update",
                            params: params,
                            callback: (res) => {
                                if (res.status == 0) {
                                    this.handleFinish(data)
                                }
                            }
                        });
                    },
                },
                { 
                    name: "求职信息", id: "jobInfo", 
                    list: [
                        { name: "是否接收倒班", props: "AWS_CN" },
                        { name: "期望岗位", props: "JOBTYPE_CN"},
                        { name: "岗位性质", props: "PROPERTY_CN" },
                        { name: "期望工作地", props: "HOPE_DISTRICT_CN" },
                        { name: "期望薪资", props: "SALFROM", type: "xinzi" },
                    ],
                    formProps: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                    },
                    formList: [
                        { 
                            name: "是否接受倒班", type: 'radio', props: "AWS",
                            formProps: { 
                                labelCol: { span: 4 },
                                wrapperCol: { span: 8 },
                            },
                            options: [{ label: '否', value: 0 },{ label: '是', value: 1 },] 
                        },
                        { name: "期望岗位", type: 'inputBlur', props: "JOBTYPE", placeholder: "请选择期望岗位", onfocus: () => {
                            this.setState({
                                jobMdal: true,
                            })
                        } },
                        { name: "岗位性质", type: 'select', props: "PROPERTY", placeholder: "请选择岗位性质", options: [
                            { label: '不限', value: '0' },
                            { label: '全职', value: '1' },
                            { label: '临时工', value: '2' },
                            // { label: '兼职', value: '3' },
                            // { label: '实习', value: '4' },

                        ] },
                        { name: "期望工作地", type: 'inputBlur', props: "DISTRICT", placeholder: "请选择期望工作地", onfocus: () => {
                            this.setState({
                                placeModal: true,
                            })
                        } },
                        { name: "期望薪资", type: 'inputNumber', props: "SAL", moreProps: ["SALFROM", "SALTO"], placeholder: "请输入姓名" },
                    ],
                    onFinish: (data, value) => {
                        const { selectJobTagsName, selectPlaceTagsName = [] } = this.state;
                        
                        let params = {
                            ...value,
                            SAL: undefined,
                            SALFROM: value.SAL.SALFROM ?? undefined,
                            SALTO: value.SAL.SALTO ?? undefined,
                            id: applicant_id,
                            PROPERTY: value.PROPERTY ? [value.PROPERTY] : [],
                            JOBTYPE: selectJobTagsName.map(item => item.value || item.code),
                            DISTRICT: selectPlaceTagsName.map(item => item.code),
                        }

                        
                        WidgetAjax.ajax({
                            url: path + '/applicant/update_intention',
                            params: params,
                            callback: (res) => {
                                if (res.status == 0) {
                                    this.handleFinish(data)
                                }
                            }
                        })
                        
                    },
                },
                { 
                    name: "工作经历", id: "workHistory", 
                    smallTitle: "担任职位",
                    smallTitleProps: "JOBTYPE_CN",
                    contentList: [
                        { label: "工作时间", type: "timeMore", props: ['OCCFROM', 'OCCTO'] },
                        { label: "工作职责", props: "DETAIL" },
                    ],
                    titleProps: "ENTNAME",
                    onFinish: (data, value) => {
                        let params = {
                            applicant_id: applicant_id,
                            occupations: value.occupation.map(item => {
                                return {
                                    ...item,
                                    OCCFROM: item.OCCDATE && item.OCCDATE.length > 0 ? item.OCCDATE[0]: undefined,
                                    OCCTO: item.OCCDATE && item.OCCDATE.length > 0 ? item.OCCDATE[1] : undefined,
                                    OCCDATE: undefined,
                                }
                            }),
                        }
                        WidgetAjax.ajax({
                            url: path + '/applicant/set_occupation',
                            params: params,
                            callback: (res) => {
                                if (res.status == 0) {
                                    this.handleFinish(data)
                                }
                            }
                        })
                    },
                    listProps: "occupation",
                    formList: [
                        { name: "公司名称", type: 'input', props: "ENTNAME", placeholder: "请输入公司名称" },
                        { name: "职位名称", type: 'input', props: "POSITION", placeholder: "请输入职位名称" },
                        { 
                            name: "岗位类型", type: 'inputBlur', props: "JOBTYPE_CN", placeholder: "请选择岗位类型", 
                            onfocus: (index) => {
                                this.setState({
                                    jobTypeModal: true,
                                    chooseJobTypeIndex: index,
                                    selectJobType: {},
                                    selectTabValue: 0,
                                })
                            } 
                        },
                        { name: "工作内容", type: 'textarea', props: "DETAIL", placeholder: "请输入工作内容" },
                        { name: "入职时间", type: 'customDate', props: "OCCDATE", placeholder: "请输选择" },
                    ],
                    formProps: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                    },
                },
                { 
                    name: "教育经历", id: "EdcHistory", 
                    smallTitle: "学历学位",
                    smallTitleProps: "EDU_CN",
                    contentList: [
                        { label: "在校时间", props:['ENRFROM', 'ENRTO'], type: "timeMore" },
                        { label: "专业名称", props: "MAJOR" },
                    ],
                    listProps: "education",
                    titleProps: "SCHOOL",
                    formList: [
                        { name: "学校名称", type: 'input', props: "SCHOOL", placeholder: "请输入学校名称" },
                        { name: "专业名称", type: 'input', props: "MAJOR", placeholder: "请输入专业名称" },
                        { name: "学历", type: 'select', props: "EDU", placeholder: "请选择学历", options: [], optionsProps: "eduOptions" },
                        { name: "入学时间", type: 'customDate', props: "ENRDATE", placeholder: "请输选择" },
                    ],
                    onFinish: (data, value) => {
                        let params = {
                            applicant_id: applicant_id,
                            educations: value.education.map(item => {
                                return {
                                    ...item,
                                    ENRFROM: item.ENRDATE && item.ENRDATE.length > 0 ? item.ENRDATE[0]: undefined,
                                    ENRTO: item.ENRDATE && item.ENRDATE.length > 0 ? item.ENRDATE[1] : undefined,
                                    ENRDATE: undefined,
                                }
                            }),
                        }
                        WidgetAjax.ajax({
                            url: path + '/applicant/set_education',
                            params: params,
                            callback: (res) => {
                                if (res.status == 0) {
                                    this.handleFinish(data)
                                }
                            }
                        })
                    },
                    formProps: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                    },
                },
                { 
                    name: "职业技能", id: "jobSkill", 
                    contentList: [
                        { label: "熟练度", props: "PROFLVL_CN" },
                    ],
                    listProps: "skill",
                    titleProps: "SKLNAME",
                    formList: [
                        { name: "技能名称", type: 'input', props: "SKLNAME", placeholder: "请输入技能名称" },
                        { name: "熟练程度", type: 'select', props: "PROFLVL", placeholder: "请选择熟练程度", options: [], optionsProps: 'skilledOptions'  },
                    ],
                    onFinish: (data, value) => {
                        const { info } = this.state;
                        WidgetAjax.ajax({
                            url: path + '/applicant/set_skill',
                            params: {
                                applicant_id: applicant_id,
                                skills: value.skill,
                            },
                            callback: (res) => {
                                if (res.status == 0)
                                {
                                    this.handleFinish(data)
                                }
                            }

                        })
                    },
                    formProps: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                    },
                },
            ],
            eduOptions: [],
            statusOptions: [],
            skilledOptions: [],
            positionModal: false,
            positionList: [],
            selectPositionList: [],
            placeModal: false,
            placeList: [],
            selectPlace: undefined,
            jobTypeModal: false,
            jobTypeList: [],
            selectJobType: undefined,
            selectTabValue: 0,
            occupation: [{}],
            education: [ ],
            skill: [],
            selectJobTags: [],
            selectJobTagsName: [],
            selectPlaceTags: [],
            selectPlaceTagsName: [],
            monmentId: null,
            fileList: [],
        }
    }


    jobConfirm = () => {
        const { selectJobTagsName } = this.state;
        if (this.formRef1)
        {
            this.setState({
                jobMdal: false,
            });
            let name = selectJobTagsName.map(item => item.name)
            this.formRef1.setFieldsValue({
                JOBTYPE: name.join(','),
            });
        }
    }
    
    placeConfirm = () =>  {
        const { selectPlaceTagsName } = this.state;
        if (this.formRef1)
        {
            this.setState({
                placeModal: false,
            });
            let name = selectPlaceTagsName.map(item => item.name);
            this.formRef1.setFieldsValue({
                DISTRICT: name.join(','),
            });
        }
    }

    // 岗位类型选择
    jobTypeHandle = () => {
        const { selectJobType, chooseJobTypeIndex } = this.state;

        if (this.formRef2)
        {
            let occupation = this.formRef2.getFieldsValue().occupation;

            occupation[chooseJobTypeIndex].JOBTYPE_CN = selectJobType.name;
            occupation[chooseJobTypeIndex].JOBTYPE = selectJobType.code;

            
            this.formRef2.setFieldValue({
                occupation: occupation,
            });
            this.setState({
                jobTypeModal: false,
                selectJobType: {},
                selectTabValue: 0,
            })
        }
    }
    // 保存完成时调用
    handleFinish = (data) => {
        WidgetMessage.success('保存成功');
        this.resetValue(data, 'finish')
        this.loadUserResume();
    }
    
    // 重置数据
    resetValue = (data, type) => {
        this.setState({
            isEditObj: {
                ...this.state.isEditObj,
                [data.id]: false,
            }
        })
    }
    // 展示内容设置
    setContent = (data) => {
        const { info } = this.state;
        switch (data.type)
        {
            case 'xinzi':
                return setXinZi(info);
            case 'STLDISTRICT':
                return <>{info.STLDISTRICT == info.DISTRICT ? "是" : "否"}</>
            default:
                return <>{data.props && info && info[data.props] !== '' ? (info[data.props] ?? '未填写') : '未填写'}</>
        }
    }
    // 处理步骤条内容展示
    setStepContentText = (item, data) => {
        switch (item.type)
        {
            case 'timeMore':
                return <>{data[item.props[0]] && data[item.props[1]] ? data[item.props[0]] + '~' + data[item.props[1]] : "-"}</>
            default:
                return <>{data[item.props] ?? '-'}</>
        }
    }
    // 步骤条显示
    setStepContent = (data) => {
        let list = this.state[data.listProps].map(item => {
            return {
                title: <div className="sf-resume-history-title">
                    <span>{item[data.titleProps] || '-'}</span>
                    {
                        data.smallTitle && data.smallTitle !== ''
                        ?   <div className="sf-resume-history-second-title">{data.smallTitle + '：' + (item[data.smallTitleProps] ?? '-')}</div>
                        :   <></>
                    }
                    
                </div>,
                description: <div className="sf-resume-history-content">
                    {
                        data.contentList.map((content, index) => {
                            return <div key={index} className="sf-resume-history-content-item">
                                <label>{content.label}：</label>
                                <div>{this.setStepContentText(content, item)}</div>
                            </div>
                        })
                    }
                </div>
            }
        })
        return list
    }
    // 跳转AI
    turnToAi = () => {
        this.props.history.push({
            pathname: "/home/ai-chat",
            state: {
                scene: "简历"
            }
        })
    }
    // 处理form表单
    setFormContent = (formItem, index, form, modal) => {
        const { info } = this.state;
        let date = new Date();
        switch (formItem.type)
        {
            case 'input':
                return <Input disabled={formItem.props == 'CELL'} placeholder={formItem.placeholder || '请输入'} />;
            case 'inputBlur':
                return <Input placeholder={formItem.placeholder || '请输入'} onClick={() => {formItem.onfocus(index, form, modal)}} />;
            case 'select':
                return <Select placeholder={formItem.placeholder || '请选择'} options={formItem.optionsProps ? (this.state[formItem.optionsProps] ?? []) :  formItem.options} />
            case 'radio':
                return  <Radio.Group
                            block
                            options={formItem.options}
                            defaultValue="Apple"
                            optionType="button"
                            buttonStyle="solid"
                        />
            case 'DatePicker':
                return <DatePicker locale={locale} placeholder={formItem.placeholder || '请选择日期'} />
            case 'customDate':
                sleep(1000);
                let listValue = this[form]?.getFieldsValue()[modal.listProps];
                
                return <WidgetPositionDate
                            picker="month"
                            maxDate={date.getFullYear() + (date.getMonth() + 1 > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1))}
                            dateFormat="YYYY-MM"
                            defaultValue={listValue && listValue[index] && listValue[index][formItem.props] ? listValue[index][formItem.props] : []}
                            onChange={(value) => {
                                let items = this[form]?.getFieldsValue()[modal.listProps];
                                if (value && value[0] && value[1])
                                {
                                    items[index][formItem.props] = [value[0], value[1]]
                                    this[form].setFieldValue({
                                        [modal.listProps]: items
                                    })
                                }
                                // this.handleRangeChange(type, index, value[0], value[1], 'OCC'); 
                                // formValue[infoType][index][data.props] = value;
                            }}
                            options={{ type: "range" }} 
                        />

            case 'inputNumber':
                return  <Space>
                    <Form.Item
                        name={[formItem.props, formItem.moreProps[0]]}
                        noStyle
                    >
                        <InputNumber min={0} />
                    </Form.Item>
                    -
                    <Form.Item
                        name={[formItem.props, formItem.moreProps[1]]}
                        noStyle
                    >
                        <InputNumber  min={0} />
                    </Form.Item>
                </Space>
            case 'textarea':
                return  <Input.TextArea 
                            rows={5}
                            style={{ resize: "none" }}
                            placeholder={formItem.placeholder || '请输入'}
                        />
        }
    }
    // 获取维度
    getDimension = (code) => {
        const onGetDimension = (res) => {
            if (res.status == 0) {
                if (code == "D301") this.setState({ eduOptions: res.results[0].values.map(item => { return { ...item, label: item.name } }) })
                if (code == "D307") this.setState({ statusOptions: res.results[0].values.map(item => { return { ...item, label: item.name } }) })
                if (code == "D311") this.setState({ skilledOptions: res.results[0].values.map(item => { return { ...item, label: item.name } }) })
            }
        }
        WidgetAjax.ajax({ url: path + '/widget/dimension', params: { dimension: code }, callback: onGetDimension })
    }
    // 获取岗位类型 
    getJobList = (value) =>
    {
        const onGetJobData = (res) => {
            if (res.status == 0) {
                this.setState({
                    jobTypeList: res.results.map(item => {
                        return {
                            ...item,
                            title: item.name,
                            value: item.code,
                        }
                    })
                })
            }
        }
        WidgetAjax.ajax({ url: path + '/recruitment/job_type', params: { parent_code: "0", word: value }, callback: onGetJobData })
    }
    // 获取地区
    getAreaData = () => {
        const onGetAreaData = (res) => {
            if (res.status == 0) {
                this.setState({
                    placeList: res.results[0].children
                })
            }
        }
        WidgetAjax.ajax({ url: path + '/recruitment/district', params: {  }, callback: onGetAreaData })
    }

    jobSearch = (value) => {
        this.getJobList(value)
    }

    // 获取用户简历信息
    loadUserResume = () => {

        let useInfo = JSON.parse(sessionStorage.getItem('_user_info_'))
        console.log("****");
        const onGetData = (res) => {

            if (res.status == 0)
            {
                let data = res.result;
                console.log(!data.intention.AWS ? "-" : 
                    data.intention && data.intention.AWS && (data.intention.AWS == 1 || data.intention.AWS == "1") ? "是" : "否",'-------');
                this.setState({
                    info: {
                        ...data,
                        "SALFROM": data.intention.SALFROM || 0,
                        "SALTO": data.intention.SALTO || 0,
                        AWS_CN: !data.intention.AWS ? "-" : 
                        data.intention && data.intention.AWS && (data.intention.AWS == 1 || data.intention.AWS == "1") ? "是" : "否",
                        PROPERTY_CN: data.intention && data.intention.PROPERTY && data.intention.PROPERTY.length > 0 ? data.intention.PROPERTY.map(item => item.name)[0]: undefined,
                        JOBTYPE_CN: data.intention && data.intention.JOBTYPE && data.intention.JOBTYPE.length > 0 ? data.intention.JOBTYPE.map(item => item.name).join(', ') : undefined,
                        HOPE_DISTRICT_CN: data.intention && data.intention.DISTRICT && data.intention.DISTRICT.length > 0 ? data.intention.DISTRICT.map(item => item.name).join(',') : undefined,
                    },
                    noDealWithInfo: data,
                    skill: data.skills || [],
                    education: data.educations || [],
                    occupation: data.occupations || [],
                    selectJobTagsName: data.intention && data.intention.JOBTYPE && data.intention.JOBTYPE.length > 0 ? data.intention.JOBTYPE : [],
                    selectJobTags: data.intention && data.intention.JOBTYPE && data.intention.JOBTYPE.length > 0 ? data.intention.JOBTYPE.map(item => item.value) : [],
                    selectPlaceTagsName: data.intention && data.intention.DISTRICT && data.intention.DISTRICT.length > 0 ? data.intention.DISTRICT : [],
                    selectPlaceTags: data.intention && data.intention.DISTRICT && data.intention.DISTRICT.length > 0 ? data.intention.DISTRICT.map(item => item.value) : [],
                    fileList: data.LOGO ? [
                        {
                            uid: '-1',
                            name: 'LOGO',
                            status: 'done',
                            url: `${filePath + 'applicant/M' + useInfo.extensions.applicant_id + '.png'}`,
                        }
                    ] : [],
                });

                let params1 = {
                    ...data,
                    BRTHDATE: data.BRTHDATE && data.BRTHDATE !== '' ? dayjs(data.BRTHDATE) : undefined,
                    WKDATE: data.WKDATE && data.WKDATE !== '' ? dayjs(data.WKDATE) : undefined,
                    STLDISTRICT:  data.DISTRICT && data.STLDISTRICT && (data.DISTRICT == data.STLDISTRICT)  ? 1 : 0,
                };
                let params2 = {
                    ...data,
                    DISTRICT: data.intention && data.intention.DISTRICT && data.intention.DISTRICT.length > 0 ? data.intention.DISTRICT.map(item => item.name).join(',') : undefined,
                    JOBTYPE: data.intention && data.intention.JOBTYPE && data.intention.JOBTYPE.length > 0 ? data.intention.JOBTYPE.map(item => item.name).join(',') : undefined,
                    "SAL" :{
                        "SALFROM": data.intention.SALFROM || 0,
                        "SALTO": data.intention.SALTO || 0,
                    },
                    PROPERTY: data.intention && data.intention.PROPERTY && data.intention.PROPERTY.length > 0 ? data.intention.PROPERTY.map(item => item.value)[0]: undefined,
                    // STLNAT: data.STLNAT ? Number(res.result.STLNAT) : undefined,
                    AWS: data.intention && data.intention.AWS ? Number(data.intention.AWS) : undefined,
                }

                let params3 = {
                    education: data.educations.map(item => {
                        return {
                            ...item,
                            ENRDATE: [item.ENRFROM, item.ENRTO]
                        }
                    }) || [],
                }

                // this.formRef0.setFieldsValue(params1)
                if (this.formRef1) {
                    this.formRef1.setFieldsValue(params2)
                }

                if( this.props.notify )
                {
                    this.props.notify(res.result, "resume-info")
                }
            }
        }
        WidgetAjax.ajax({ url: path + "/applicant/resume_info", params: { id: useInfo?.extensions?.applicant_id }, callback: onGetData }, this.props)
    }

    // 编辑设置form值
    setFormValue = (type) => {
        const { info } = this.state;

        switch (type)
        {
            case 'baseInfo':
                let params0 = {
                    ...info,
                    BRTHDATE: info.BRTHDATE && info.BRTHDATE !== '' ? dayjs(info.BRTHDATE) : undefined,
                    WKDATE: info.WKDATE && info.WKDATE !== '' ? dayjs(info.WKDATE) : undefined,
                    STLDISTRICT:  info.DISTRICT && info.STLDISTRICT && (info.DISTRICT == info.STLDISTRICT)  ? 1 : 0,
                };
                this.formRef0.setFieldsValue(params0)
                break;
            case 'jobInfo':
                let params1 = {
                    ...info,
                    DISTRICT: info.intention && info.intention.DISTRICT && info.intention.DISTRICT.length > 0 ? info.intention.DISTRICT.map(item => item.name).join(',') : undefined,
                    JOBTYPE: info.intention && info.intention.JOBTYPE && info.intention.JOBTYPE.length> 0 ? info.intention.JOBTYPE.map(item => item.name).join(',') : undefined,
                    PROPERTY: info.intention && info.intention.PROPERTY && info.intention.PROPERTY.length > 0 ? info.intention.PROPERTY.map(item => item.value)[0]: undefined,
                    "SAL" :{
                        "SALFROM": info.intention.SALFROM || 0,
                        "SALTO": info.intention.SALTO || 0,
                    },
                    AWS: info.intention && info.intention.AWS ? Number(info.intention.AWS) : undefined,
                }
                this.setState({
                    selectJobTagsName: info.intention && info.intention.JOBTYPE && info.intention.JOBTYPE.length > 0 ? info.intention.JOBTYPE.map(item => {
                        return {
                            ...item,
                            code: item.value,
                        }
                    }) : undefined,
                    selectJobTags: info.intention && info.intention.JOBTYPE && info.intention.JOBTYPE.length > 0 ? info.intention.JOBTYPE.map(item => item.value) : undefined,
                    selectPlaceTagsName: info.intention && info.intention.DISTRICT && info.intention.DISTRICT.length > 0 ? info.intention.DISTRICT : [],
                    selectPlaceTags: info.intention && info.intention.DISTRICT && info.intention.DISTRICT.length > 0 ? info.intention.DISTRICT.map(item => item.value) : [],
                })
                if (this.formRef1) {
                    this.formRef1.setFieldsValue(params1);
                }
                break;
            case 'workHistory':
                let params2 = {
                    occupation: info.occupations.map(item => {
                        return {
                            ...item,
                            OCCDATE: [item.OCCFROM, item.OCCTO],
                        }
                    })
                };
                if (this.formRef2) {
                    this.formRef2.setFieldsValue(params2)
                }
                break;
            case 'EdcHistory':
                let params3 = {
                    education: info.educations.map(item => {
                        return {
                            ...item,
                            ENRDATE: [item.ENRFROM, item.ENRTO],
                        }
                    })
                }

                if (this.formRef3) 
                {
                    this.formRef3.setFieldsValue(params3);
                }
                break;
            case 'jobSkill':

                let params4 = {
                    skill: info.skills
                }

                this.formRef4.setFieldsValue(params4)
                break;
        }

    }

    // 点击编辑按钮
    handleEdit = async (item) => {

        const {isEditObj} = this.state;
        if (isEditObj.jobSkill || isEditObj.jobInfo || isEditObj.baseInfo || isEditObj.workHistory || isEditObj.EdcHistory)
        {
            this.setState({
                tooltipVisible: true,
                monmentId: item.id,
            })
        } 
        else 
        {
            await this.setState({ 
                isEditObj: {
                    [item.id]: true
                } 
            })
            this.setFormValue(item.id)
        }
    }

    // 弹窗确认
    tooltipConfirm = async () =>  {
        const { monmentId } = this.state;
        await this.setState({
            tooltipVisible: false,
            isEditObj: {
                [monmentId]: true
            },
        })
        this.setFormValue(monmentId)
    }

    tooltipCancel = () =>  {
        this.setState({
            tooltipVisible: false,
            monmentId: null,
        })
    }

    getBase64 = (file) => {
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    }
        
    // 头像预览
    avatarHandlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await this.getBase64(file.originFileObj);
        }
        this.setState({
            previewImage: file.url || file.preview,
            previewOpen: true,
        });
    };

    // 头像文件改变
    avatarHandleChange = ({ fileList: newFileList }) => {
        this.setState({
            fileList: newFileList,
        })
    }

    componentDidMount()
    {
        Promise.allSettled([
            this.loadUserResume(),
            this.getDimension("D301"),
            this.getDimension("D307"),
            this.getDimension("D311"),
            this.getJobList(),
            this.getAreaData(),
        ])
    }

    render()
    {
        const { info, isEditObj, resumeList, placeModal, placeList, jobTypeModal, jobTypeList, selectJobType, selectTabValue, 
            education, skill, occupation, jobMdal = false, selectJobTags = [], selectJobTagsName = [], selectPlaceTags = [],
             selectPlaceTagsName = [], applicant_id, tooltipVisible = false, fileList = [], previewImage, previewOpen } = this.state;

        return (
            <div component-data="resume" className="sf-resume-wrap" id="mine_resume">
                <div className="sf-resume-box">
                    <div className="sf-resume-info">
                        <div className="sf-resume-title">简历信息</div>
                        {
                            resumeList.map((item, index) => {
                                return <div className="sf-resume-modal" key={index} id={item.id}>
                                    <div className="sf-resume-modal-title">
                                        <span className="sf-resume-modal-line"></span>
                                        <span>{item.name}</span>
                                        {
                                            isEditObj && isEditObj[item.id]
                                            ?   <></>
                                            :   <div className="sf-resume-modal-btn" onClick={() => this.handleEdit(item)}>编辑</div>
                                        }
                                        
                                    </div>
                                        {
                                            isEditObj && isEditObj[item.id]
                                            ?   <div className="sf-resume-form-wrap">
                                                    <Form
                                                        ref={ref => this['formRef' + index] = ref}
                                                        onFinish={(value) => item.onFinish(item, value)}
                                                        onReset={() => this.resetValue(item, 'reset')}
                                                        {...item.formProps || {}}
                                                        className={`sf-resume-form-${item.id}`}
                                                        initialValues={
                                                            item.id !== 'baseInfo' && item.id !== 'jobInfo' 
                                                            ?   {
                                                                    education: education,
                                                                    skill: skill,
                                                                    occupation: occupation,
                                                                } 
                                                            : {}
                                                        }
                                                    >
                                                        {
                                                            item.id == 'baseInfo' || item.id == 'jobInfo'
                                                            ?   item.formList && item.formList.length > 0
                                                                ?   <div className="sf-resume-form-wrap-box">
                                                                        {
                                                                            item.formList.map((formItem, formIndex) => {
                                                                                return  <Form.Item 
                                                                                            label={formItem.name} 
                                                                                            name={formItem.props} 
                                                                                            key={formIndex} 
                                                                                            className={formItem.className || ''} 
                                                                                            {...formItem.formProps || {}}
                                                                                        >
                                                                                            {this.setFormContent(formItem, item)}
                                                                                        </Form.Item>
                                                                            })
                                                                        }
                                                                    </div>
                                                                :   <></>
                                                            :   <Form.List name={item.listProps}>
                                                                    {(fields, { add, remove }) => (
                                                                        <div style={{ display: 'flex', rowGap: 16, flexDirection: 'column' }} className="sf-resume-form-wrap-box">
                                                                            {
                                                                                fields.map((field) => (
                                                                                    <div
                                                                                        key={field.key}
                                                                                    >
                                                                                        <div style={{ display: "flex", alignItems: "center", gap: "5px", padding: "0 20px" }}>
                                                                                            <span>{field.name + 1}</span>
                                                                                            <Divider />
                                                                                            <img src={require('../../img/resume/delete.png')} style={{ width: "15px", height: "15px", cursor: "pointer" }} onClick={() => remove(field.name)} />
                                                                                        </div>
                                                                                        {
                                                                                            item.formList.map((formItem, formIndex) => {
                                                                                                return  <Form.Item 
                                                                                                            label={formItem.name} 
                                                                                                            name={[field.name, formItem.props]} 
                                                                                                            key={formIndex} 
                                                                                                            className={formItem.className || ''} 
                                                                                                            {...formItem.formProps || {}}
                                                                                                        >
                                                                                                            {this.setFormContent(formItem, field.name, 'formRef' + index, item)}
                                                                                                        </Form.Item>
                                                                                            })
                                                                                        }
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                                                                                <PlusCircleOutlined onClick={() => add()} style={{ fontSize: "16px", color: "#E2211C" }} />
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </Form.List>
                                                        }
                                                        <Form.Item labelCol={{ span: 0 }} wrapperCol={{ span: 24 }} style={{ width: "50%" }}>
                                                            <div className="sf-resume-form-btn">
                                                                <Button htmlType="reset">取消</Button>
                                                                <Button type="primary" htmlType="submit">保存</Button>
                                                            </div>
                                                        </Form.Item>
                                                    </Form>
                                                    {/* {
                                                        item.id == 'baseInfo'
                                                        ?   <div className="sf-resume-baseinfo-avatarUpload">
                                                                <Upload
                                                                    action={path + '/applicant/logo_import'}
                                                                    listType="picture-circle"
                                                                    fileList={fileList}
                                                                    onPreview={this.avatarHandlePreview}
                                                                    onChange={this.avatarHandleChange}
                                                                    maxCount={1}
                                                                    // name="filename"
                                                                    data={{
                                                                        id: applicant_id
                                                                    }}
                                                                    headers={{
                                                                        "Authorization": "Access " + sessionStorage.getItem("_user_access_")
                                                                    }}
                                                                >
                                                                    {
                                                                        fileList.length >= 1 
                                                                        ?   null 
                                                                        :   <>
                                                                                <button style={{ border: 0, background: 'none' }} type="button">
                                                                                    <PlusOutlined />
                                                                                    <div style={{ marginTop: 8 }}>上传头像</div>
                                                                                </button>
                                                                            </>
                                                                    }
                                                                </Upload>
                                                                {previewImage && (
                                                                    <Image
                                                                        wrapperStyle={{ display: 'none' }}
                                                                        preview={{
                                                                            visible: previewOpen,
                                                                            onVisibleChange: (visible) => this.setState({previewOpen: visible}),
                                                                            afterOpenChange: (visible) => !visible && this.setState({previewImage: ''}),
                                                                        }}
                                                                        src={previewImage}
                                                                    />
                                                                )}
                                                            </div>

                                                        :   <></>
                                                    } */}
                                                </div>
                                            :   <>
                                                    {
                                                        item.id == 'baseInfo'
                                                        ?   <>
                                                                <div className="sf-resume-baseInfo-title">{info.PERNAME ?? '未填写姓名'}</div>
                                                                <div className="sf-resume-baseInfo-content">
                                                                    <div className="sf-resume-baseInfo-content-info">
                                                                        {
                                                                            item.list.map((iItem, iIndex) => {
                                                                                return <div className="sf-resume-baseInfo-content-info-item" key={iIndex}>
                                                                                    <label>{iItem.name}</label>
                                                                                    <div>{this.setContent(iItem)}</div>
                                                                                </div>
                                                                            })
                                                                        }
                                                                    </div>
                                                                    {/* <div className="sf-resume-baseInfo-content-img">
                                                                        <img src={info && info.LOGO ? filePath + 'applicant/M' + applicant_id + '.png' : require('../../img/dataSource/no-img.png')} alt="" />
                                                                    </div> */}
                                                                </div>
                                                            </>
                                                        :   <></>
                                                    }
                                                    {
                                                        item.id == 'jobInfo'
                                                        ?   <>
                                                                <div className="resume_jobInfo_content">
                                                                    <div className="resume_jobInfo_content_info">
                                                                        {
                                                                            item.list.map((iItem, iIndex) => {
                                                                                return <div className="sf-resume-jobInfo-content-info-item" key={iIndex}>
                                                                                    <label>{iItem.name}</label>
                                                                                    <div>{this.setContent(iItem)}</div>
                                                                                </div>
                                                                            })
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </>
                                                        :   <></>
                                                    }
                                                    {
                                                        item.id == 'workHistory' || item.id == 'EdcHistory' || item.id == 'jobSkill'
                                                        ?   <>
                                                                {
                                                                    this.state[item.listProps] && this.state[item.listProps].length > 0
                                                                    ?   <Steps
                                                                            progressDot
                                                                            current={this.state[item.listProps].length}
                                                                            direction="vertical"
                                                                            items={this.setStepContent(item)}
                                                                        />
                                                                    :   <>未填写</>
                                                                }
                                                            </>
                                                        :   <></>
                                                    }
                                                </>
                                        }
                                </div>
                            })
                        }
                    </div>
                    
                    <Modal
                        title="期望岗位选择"
                        visible={jobMdal}
                        centered
                        footer={[
                            <Button type="primary" onClick={() => {
                                this.jobConfirm();
                            }}>
                                确认
                            </Button>,
                        ]}
                        onCancel={() => {
                            this.setState({
                                jobMdal: false,
                                selectTabValue: 0, 
                            })
                            return false
                        }}
                        getContainer={false}
                        width={600}
                        wrapClassName="sf-job-wrap-box"
                    >
                        <div className="sf-job-search-box">
                            <Input onChange={(e) => this.jobSearch(e.target.value)} />
                        </div>
                        <div className="sf-laogong-job">
                            <ul className="sf-laogong-job-left">
                                {
                                    jobTypeList.map((item, index) => {
                                        return <li 
                                            key={index} 
                                            onClick={() => this.setState({ selectTabValue: index })} 
                                            className={selectTabValue == index ? "sf-laogong-job-left-active" : ""}
                                        >{item.name}</li>
                                    })
                                }
                            </ul>
                            <ul className="sf-laogong-job-right">
                                {
                                    jobTypeList[selectTabValue] && jobTypeList[selectTabValue].children && jobTypeList[selectTabValue].children.length > 0 ?
                                        jobTypeList[selectTabValue].children.map((item, index) => {
                                            return <li onClick={async () => {
                                                if (!selectJobTags.includes(item.code)) {
                                                    if (selectJobTags.length >= 5) {
                                                        WidgetMessage.warning('最多只可选5个职位！')
                                                    } else {
                                                        console.log(selectJobTags, item,'selectJobTags=============item');
                                                        
                                                        await this.setState({
                                                            selectJobTags: [
                                                                ...selectJobTags,
                                                                item.code,
                                                            ],
                                                            selectJobTagsName: [
                                                                ...selectJobTagsName,
                                                                item,
                                                            ],
                                                        })
                                                    }
                                                } else {
                                                    await this.setState({
                                                        selectJobTags: selectJobTags.filter(vitem => vitem !== item.code),
                                                        selectJobTagsName: selectJobTagsName.filter(vitem => vitem.code !== item.code),
                                                    })
                                                }
                                            }} key={index} className={selectJobTags.includes(item.code) ? "sf-laogong-job-right-active" : ""}>{item.name}</li>
                                        })
                                        : <></>
                                }
                            </ul>
                        </div>
                        <div className="sf-has-select-wrap">
                            <div className="sf-has-select-top">
                                <div className="sf-has-select-title">我选择的岗位</div>
                                <div className="sf-has-select-num">已选{selectJobTagsName.length} / 5</div>
                            </div>
                            <ul>
                                {
                                    selectJobTagsName.map((item, index) => {
                                        return <li key={index} className="sf-laogong-job-right-item">
                                            {item.name}
                                            <span className="sf-has-select-close" onClick={async () => {
                                                await this.setState({
                                                    selectJobTags: selectJobTags.filter(vitem => vitem !== item.code),
                                                    selectJobTagsName: selectJobTagsName.filter(vitem => vitem.code !== item.code),
                                                })
                                            }}>
                                                <CloseOutlined />
                                            </span>
                                        </li>
                                    })
                                }
                            </ul>
                        </div>
                    </Modal>
                    <Modal
                        title="期望工作地选择"
                        visible={placeModal}
                        centered
                        footer={[
                            <Button type="primary" onClick={() => {
                                this.placeConfirm();
                            }}>
                                确认
                            </Button>,
                        ]}
                        onCancel={() => {
                            this.setState({
                                placeModal: false,
                                selectTabValue: 0, 
                            })
                            return false
                        }}
                        getContainer={false}
                        width={600}
                        wrapClassName="sf-job-wrap-box"
                    >
                        <div className="sf-laogong-job">
                            <ul className="sf-laogong-job-left">
                                {
                                    placeList.map((item, index) => {
                                        return <li 
                                            key={index} 
                                            onClick={() => this.setState({ selectTabValue: index })} 
                                            className={selectTabValue == index ? "sf-laogong-job-left-active" : ""}
                                        >{item.name}</li>
                                    })
                                }
                            </ul>
                            <ul className="sf-laogong-job-right">
                                {
                                    placeList[selectTabValue] && placeList[selectTabValue].children && placeList[selectTabValue].children.length > 0 ?
                                    placeList[selectTabValue].children.map((item, index) => {
                                            return <li onClick={async () => {
                                                if (!selectPlaceTags.includes(item.code)) {
                                                    if (selectPlaceTags.length >= 5) {
                                                        WidgetMessage.warning('最多只可选5个地区！')
                                                    } else {

                                                        await this.setState({
                                                            selectPlaceTags: [
                                                                ...selectPlaceTags,
                                                                item.code,
                                                            ],
                                                            selectPlaceTagsName: [
                                                                ...selectPlaceTagsName,
                                                                item,
                                                            ],
                                                        })
                                                    }
                                                } else {
                                                    await this.setState({
                                                        selectPlaceTags: selectPlaceTags.filter(vitem => vitem !== item.code),
                                                        selectPlaceTagsName: selectPlaceTagsName.filter(vitem => vitem.code !== item.code),
                                                    })
                                                }
                                            }} key={index} className={selectPlaceTags.includes(item.code) ? "sf-laogong-job-right-active" : ""}>{item.name}</li>
                                        })
                                        : <></>
                                }
                            </ul>
                        </div>
                        <div className="sf-has-select-wrap">
                            <div className="sf-has-select-top">
                                <div className="sf-has-select-title">我选择的地区</div>
                                <div className="sf-has-select-num">已选{selectPlaceTagsName.length} / 5</div>
                            </div>
                            <ul>
                                {
                                    selectPlaceTagsName.map((item, index) => {
                                        return <li key={index} className="sf-laogong-job-right-item">
                                            {item.name}
                                            <span className="sf-has-select-close" onClick={async () => {
                                                await this.setState({
                                                    selectPlaceTags: selectPlaceTags.filter(vitem => vitem !== item.code),
                                                    selectPlaceTagsName: selectPlaceTagsName.filter(vitem => vitem.code !== item.code),
                                                })
                                            }}>
                                                <CloseOutlined />
                                            </span>
                                        </li>
                                    })
                                }
                            </ul>
                        </div>
                    </Modal>
                    <Modal
                        title="岗位类型选择"
                        visible={jobTypeModal}
                        centered
                        footer={[
                            <Button type="primary" onClick={() => this.jobTypeHandle()}>
                                确认
                            </Button>,
                        ]}
                        onCancel={() => {
                            this.setState({
                                jobTypeModal: false,
                            })
                            return false
                        }}
                        getContainer={false}
                        width={600}
                        wrapClassName="sf-job-wrap-box"
                    >
                        <div className="sf-job-search-box">
                            <Input onChange={(e) => this.jobSearch(e.target.value)} />
                        </div>
                        <div className="sf-laogong-job">
                            <ul className="sf-laogong-job-left">
                                {
                                    jobTypeList.map((item, index) => {
                                        return <li key={index} onClick={() => this.setState({ selectTabValue: index })} className={selectTabValue == index ? "sf-laogong-job-left-active" : ""}>{item.name}</li>
                                    })
                                }
                            </ul>
                            <ul className="sf-laogong-job-right">
                                {
                                    jobTypeList[selectTabValue] && jobTypeList[selectTabValue].children && jobTypeList[selectTabValue].children.length > 0 ?
                                        jobTypeList[selectTabValue].children.map((item, index) => {
                                            return <li onClick={() => {
                                                this.setState({
                                                    selectJobType: item
                                                })
                                            }} key={index} className={selectJobType && selectJobType.code && (selectJobType.code == item.code) ? "sf-laogong-job-right-active" : ""}>{item.name}</li>
                                        })
                                        : <></>
                                }
                            </ul>
                        </div>
                    </Modal>
                    <Modal
                        title="提示"
                        visible={tooltipVisible}
                        centered
                        footer={[
                            <Button onClick={() => this.tooltipCancel()}>
                                取消
                            </Button>,
                            <Button type="primary" onClick={() => this.tooltipConfirm()}>
                                确认
                            </Button>,
                        ]}
                        onCancel={() => {
                            this.setState({
                                tooltipVisible: false,
                            })
                            return false
                        }}
                        getContainer={false}
                        width={600}
                        wrapClassName="sf-job-wrap-box"
                    >
                        <p style={{ fontSize: "14px", lineHeight: "50px", paddingLeft: "48px", color: "#666" }}>有内容没有保存，退出编辑后，更新的内容不会自动保存!</p>
                    </Modal>
                </div>
                {/* <FileAndSecret info={info} reloadInfo={this.loadUserResume} /> */}
            </div>
        )      
    }
}
export default Resume